import { Component, Inject, OnInit } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  ReactiveFormsModule,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { MatListModule } from '@angular/material/list'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'modal-message-email',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBar,
    MatDialogClose,
  ],
  templateUrl: './modal-message-email.component.html',
  styleUrl: './modal-message-email.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalMessageEmailComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalMessageEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  loading = true
  success = true
  choice = true

  item: any = {}
  infos: any = {}

  ngOnInit(): void {
    // this.sendEmail()
  }

  sendEmail(sendEmail = false) {
    this.choice = false
    const model = {
      enviarEmail: sendEmail ? 'S' : 'N',
      propostaId: this.item.id,
    }
    this.proposalClientService.sendProposalClientEmail(model).subscribe({
      next: (response: any) => {
        this.infos = response.data
        this.loading = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.errorRequest(err)
        this.loading = false
        this.success = false
      },
      complete: () => {},
    })
  }

  close() {
    this.dialogRef.close()
  }
}
